import router from "../router/router";
import { NewsService } from "../services/News.service";
import { MessageBox, Loading } from 'element-ui';
const state = {
    dataTable: [],
    current_news: {},
    total: 0
};

const actions = {
    async addNews({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await NewsService.addNews(data);
        if (result.status === 200) {
            if (result.data.status == 1) {
                NewsService.sendNotification(result.data)
            }
            setTimeout(function(){ loadingInstance.close() }, 250);
            MessageBox.confirm('จัดเก็บข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                router.push({ name: 'Manage_news' })
            }).catch(() => {
                router.push({ name: 'Manage_news' })
            });
        } else {
            setTimeout(function(){ loadingInstance.close() }, 250);
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    })
                    .catch(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    });
            } else {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {})
                    .catch(() => {});
            }
        }
    },
    async searchNews({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await NewsService.searchNews(data);
        if (result.status === 200) {
            state.dataTable = []
            state.dataTable = result.data
            state.total = result.data.length > 0 ? result.data[0].total : 0
            setTimeout(function(){ loadingInstance.close() }, 250);
        } else {
            setTimeout(function(){ loadingInstance.close() }, 250);
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    })
                    .catch(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    });
            } else {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {})
                    .catch(() => {});
            }
        }
    },
    async getNews({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await NewsService.getNews(data);
        if (result.status === 200) {
            state.current_news = result.data[0]
            setTimeout(function(){ loadingInstance.close() }, 250);
        } else {
            setTimeout(function(){ loadingInstance.close() }, 250);
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    })
                    .catch(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    });
            } else {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {})
                    .catch(() => {});
            }
        }
    },
    async editNews({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await NewsService.editNews(data);
        if (result.status === 200) {
            setTimeout(function(){ loadingInstance.close() }, 250);
            MessageBox.confirm('แก้ไขข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                router.push({ name: 'Manage_news' })
            }).catch(() => {
                router.push({ name: 'Manage_news' })
            });
        } else {
            setTimeout(function(){ loadingInstance.close() }, 250);
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    })
                    .catch(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    });
            } else {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {})
                    .catch(() => {});
            }
        }
    },
    async remove({ commit }, data) {
        let result = await NewsService.remove(data);
        if (result.status === 200) {
            MessageBox.confirm('ลบข้อมูลเรียบร้อยแล้ว', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                // commit('CUT_TABLE', data)
            }).catch(() => {
                // commit('CUT_TABLE', data)
            });
        } else {
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    })
                    .catch(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    });
            } else {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {})
                    .catch(() => {});
            }
        }
    },
    
    async unsubscribe_news({}, email){
        if(btoa(atob(email)) !== email) return window.location.replace('https://procheck.nbtc.go.th')
        if((atob(email).match(/@/g) || []).length !== 1) return window.location.replace('https://procheck.nbtc.go.th')
        await NewsService.unsubscribe_news({email : atob(email)});
        MessageBox.confirm('ดำเนินการเรียบร้อย', "", {
            confirmButtonText: "ตกลง",
            showCancelButton: false,
            type: "success"
        }).then(()=>{
            window.location.replace('https://procheck.nbtc.go.th')
        })
    }
};

const mutations = {
    CUT_TABLE(state, data) {
        let index = state.dataTable.findIndex(x => x.news_id === data);
        state.dataTable.splice(index, 1)
    }
};


export const NewsStore = {
    namespaced: true,
    state,
    actions,
    mutations
};